function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M234 0.999977L151.6 265.8C150.533 269 148.667 271.667 146 273.8C143.333 275.933 140.267 277 136.8 277H97.2C93.4667 277 90.2667 275.933 87.6 273.8C84.9333 271.667 83.0667 269 82 265.8L2.38419e-07 0.999977H41.6L104 216.2C105.333 221.267 106.667 226.333 108 231.4C109.333 236.2 110.533 241.133 111.6 246.2H122.4C123.467 241.133 124.667 236.067 126 231C127.333 225.933 128.8 220.867 130.4 215.8L192.4 0.999977H234Z",
  fill: "#95AFE7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M292.094 227.4C297.694 227.4 301.427 228.467 303.294 230.6C305.427 232.467 306.494 236.067 306.494 241.4V262.6C306.494 267.933 305.427 271.667 303.294 273.8C301.427 275.933 297.694 277 292.094 277H280.494C275.16 277 271.427 275.933 269.294 273.8C267.16 271.667 266.094 267.933 266.094 262.6V241.4C266.094 236.067 267.16 232.467 269.294 230.6C271.427 228.467 275.16 227.4 280.494 227.4H292.094ZM406.272 0.999977V277H366.272V0.999977H406.272ZM526.513 0.599982C545.979 0.599982 565.713 0.733314 585.713 0.999977C605.979 1.26666 625.046 2.06666 642.913 3.39999L640.913 33.8H538.113C520.779 33.8 512.113 42.2 512.113 59V120.2H625.713V151.4H512.113V277H472.113V51.4C472.113 35.4 477.046 23 486.913 14.2C496.779 5.13332 509.979 0.599982 526.513 0.599982Z",
  fill: "#333333"
});

function SvgLogoTypo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 643,
    height: 277,
    viewBox: "0 0 643 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTypo);
export default __webpack_public_path__ + "static/media/logo_typo.f08ce743.svg";
export { ForwardRef as ReactComponent };